import { z } from 'zod';
import { IsoTimestamp } from './common';
import { AtsName } from './ats';

export const FindingCategory = z.enum([
  'ats-handler',
  'llm-hallucination',
  'linkedin-dom',
  'network',
  'auth',
  'budget',
  'unknown',
]);
export type FindingCategory = z.infer<typeof FindingCategory>;

export const FindingStatus = z.enum([
  'open',
  'triaging',
  'in_progress',
  'pr_open',
  'pr_merged',
  'resolved',
  'dismissed',
]);
export type FindingStatus = z.infer<typeof FindingStatus>;

export const ErrorFinding = z.object({
  findingId: z.string().uuid(),
  signature: z.string().regex(/^[0-9a-f]{64}$/),
  category: FindingCategory,
  summary: z.string().min(1).max(500),
  sampleRunIds: z.array(z.string()).max(5),
  affectedUserIds: z.array(z.string()).max(1000),
  classifierVersion: z.string(),
  status: FindingStatus,
  statusChangedAt: IsoTimestamp,
  prUrl: z.string().url().optional(),
  prState: z.enum(['open', 'merged', 'closed']).optional(),
  ats: AtsName.optional(),
  firstSeenAt: IsoTimestamp,
  lastSeenAt: IsoTimestamp,
  count: z.number().int().nonnegative(),
});
export type ErrorFinding = z.infer<typeof ErrorFinding>;

export const PatchFindingRequest = z.object({
  status: FindingStatus.optional(),
  prUrl: z.string().url().optional(),
  prState: z.enum(['open', 'merged', 'closed']).optional(),
});
export type PatchFindingRequest = z.infer<typeof PatchFindingRequest>;
